import React, { memo, useMemo } from 'react';
import { Typography, Avatar, Fade, Chip } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import md5 from 'md5';
import { ENVIRONMENT } from '@dyl/env';
import { startCase } from 'lodash';
import { useAuth } from '@dyl/systems/UserManager';

const useStyles = makeStyles(() => ({
	root: {
		padding: 16,
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'flex-start',
		alignItems: 'flex-start'
	},
	username: {
		marginTop: 12,
		width: '100%', // Of parent
		overflow: 'hidden',
		textOverflow: 'ellipsis'
	}
}));

const NavProfile = ({ ...props }) => {
	const classes = useStyles();
	const { user } = useAuth();

	/** @type {string} */
	let email = user?.attributes?.email;

	// Avatar from Gravatar, falling back to a hash-generated one
	const gravatarSrc = useMemo(() => {
		const hash = md5((email ?? '').trim().toLowerCase());

		return `https://www.gravatar.com/avatar/${hash}?d=retro`;
	}, [email]);

	return (
		<div className={classes.root} {...props}>
			<Fade in={!!email}>
				<Avatar
					src={gravatarSrc}
					style={{ marginBottom: 20 }}
				/>
			</Fade>

			<Typography variant='h6'>
				DYL Admin App {ENVIRONMENT !== 'prod' && <Chip size='small' variant='outlined' label={startCase(ENVIRONMENT)} />}
			</Typography>

			<Fade in={!!email}>
				<Typography variant='subtitle1' className={classes.username}>
					{email ?? 'Unknown user'}
				</Typography>
			</Fade>
		</div>
	);
};

export default memo(NavProfile);